"use client";
import React from "react";
import HtmlEmbed from "./webflow_modules/Embed/components/HtmlEmbed";
import Link from "./webflow_modules/Basic/components/Link";

export function SearchInputSearchButton({}) {
  return (
    <Link
      block={"inline"}
      button={false}
      className={"search_search-button---adv-search-page"}
      options={{
        href: "#",
      }}
    >
      <HtmlEmbed
        className={"icon-embed-xxsmall---adv-search-page"}
        content={
          '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="iconify iconify--fe" width="100%" height="100%" preserveaspectratio="xMidYMid meet" viewbox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="m16.325 14.899l5.38 5.38a1.008 1.008 0 0 1-1.427 1.426l-5.38-5.38a8 8 0 1 1 1.426-1.426M10 16a6 6 0 1 0 0-12a6 6 0 0 0 0 12"/></svg>'
        }
      />
    </Link>
  );
}
